export const defaultPriceRange = 100000;